const Layout = ({ children }) => (
  <div className='w-screen h-screen prose bg-black'>{children}</div>
)

export default Layout
